import * as React from 'react';

const placeholderRegex = /(\{[\d|\w]+\})/;
function template(str, valuesForPlaceholders) {
  let hasObject = false;
  const res = str.split(placeholderRegex).filter(textPart => !!textPart).map((textPart, index) => {
    if (textPart.match(placeholderRegex)) {
      const matchedKey = textPart.slice(1, -1);
      const valueForPlaceholder = valuesForPlaceholders[matchedKey];
      // If value isn't found, then it must have been undefined/null
      if (valueForPlaceholder == undefined) {
        return valueForPlaceholder;
      }
      if (/*#__PURE__*/React.isValidElement(valueForPlaceholder)) {
        hasObject = true;
        return React.Children.toArray(valueForPlaceholder).map(component => ({
          ...component,
          key: index.toString()
        }));
      }
      return valueForPlaceholder;
    }
    return textPart;
  });
  // If the results contains a object return an array otherwise return a string
  if (hasObject) return res;
  return res.join('');
}

export { template };
